import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useResponsiveDialog } from "../../../../../Context/ResponsiveDialogContext";
import { getValidationRules, isFieldRequired } from "../PreLoan";

export default function StepTenantPM() {
    const { control, formState: { errors } } = useFormContext();
    const { containerWidth } = useResponsiveDialog();

    const isSmall = containerWidth > 0 && containerWidth < 500;
    const stepKey = 'tenantPM'; // Definir el stepKey para este componente
    return (
        <div className="p-fluid">
            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-8'}`}>
                    <label htmlFor="tenant.nombreArrendamiento">Nombre del arrendamiento{isFieldRequired('tenant.nombreArrendamiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.nombreArrendamiento" control={control} rules={getValidationRules('tenant.nombreArrendamiento', stepKey)} render={({ field }) => (
                        <InputText id="tenant.nombreArrendamiento" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.nombreArrendamiento && <small className="p-error">{errors.tenant.nombreArrendamiento.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.numeroContrato">No. Contrato{isFieldRequired('tenant.numeroContrato', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.numeroContrato" control={control} rules={getValidationRules('tenant.numeroContrato', stepKey)} render={({ field }) => (
                        <InputText id="tenant.numeroContrato" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.numeroContrato && <small className="p-error">{errors.tenant.numeroContrato.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label htmlFor="tenant.domicilioOperativo">Domicilio Operativo {isFieldRequired('tenant.domicilioOperativo', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.domicilioOperativo" control={control} rules={getValidationRules('tenant.domicilioOperativo', stepKey)} render={({ field }) => (
                        <InputText id="tenant.domicilioOperativo" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.domicilioOperativo && <small className="p-error">{errors.tenant.domicilioOperativo.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label htmlFor="tenant.domicilioFiscal">Domicilio Fiscal {isFieldRequired('tenant.domicilioFiscal', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.domicilioFiscal" control={control} rules={getValidationRules('tenant.domicilioFiscal', stepKey)} render={({ field }) => (
                        <InputText id="tenant.domicilioFiscal" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.domicilioFiscal && <small className="p-error">{errors.tenant.domicilioFiscal.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.rfc">RFC{isFieldRequired('tenant.rfc', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.rfc" control={control} rules={getValidationRules('tenant.rfc', stepKey)} render={({ field }) => (
                        <InputText id="tenant.rfc" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.rfc && <small className="p-error">{errors.tenant.rfc.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.telefono">Núm. Teléfono{isFieldRequired('tenant.telefono', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.telefono" control={control} rules={getValidationRules('tenant.telefono', stepKey)} render={({ field }) => (
                        <InputText id="tenant.telefono" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.telefono && <small className="p-error">{errors.tenant.telefono.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.correo">Correo{isFieldRequired('tenant.correo', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.correo" control={control} rules={getValidationRules('tenant.correo', stepKey)} render={({ field }) => (
                        <InputText id="tenant.correo" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.correo && <small className="p-error">{errors.tenant.correo.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.fechaInscripcion">Fecha Inscripción {isFieldRequired('tenant.fechaInscripcion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fechaInscripcion" control={control} rules={getValidationRules('tenant.fechaInscripcion', stepKey)} render={({ field }) => (
                        <Calendar id="tenant.fechaInscripcion"
                         {...field} value={field.value} onChange={(e) => field.onChange(e.value)}
                          className=" w-full rounded-lg" dateFormat="yy-mm-dd"
                           showIcon
                            style={{
                            borderRadius: '17px',
                            overflow: 'hidden',
                            padding: '0',
                            width: '300px',
                            // height: '47px',
                            '& input': {
                                padding: '0.5rem 1rem',
                                borderRadius: '0px',
                            }
                        }}
                        panelStyle={{
                            borderRadius: '17px'
                        }}/>
                    )} />
                    {errors.tenant?.fechaInscripcion && <small className="p-error">{errors.tenant.fechaInscripcion.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.fechaConstitucion">F Constitución {isFieldRequired('tenant.fechaConstitucion', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fechaConstitucion" control={control} rules={getValidationRules('tenant.fechaConstitucion', stepKey)} render={({ field }) => (
                        <Calendar id="tenant.fechaConstitucion" {...field} value={field.value} onChange={(e) => field.onChange(e.value)} className="w-full" dateFormat="yy-mm-dd" showIcon style={{
                            borderRadius: '17px',
                            overflow: 'hidden',
                            padding: '0',
                            width: '300px',
                            // height: '47px',
                            '& input': {
                                padding: '0.5rem 1rem',
                                borderRadius: '0px',
                            }
                        }} panelStyle={{
                            borderRadius: '17px'
                        }}/>
                    )} />
                    {errors.tenant?.fechaConstitucion && <small className="p-error">{errors.tenant.fechaConstitucion.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.fechaRegistro">F Registro {isFieldRequired('tenant.fechaRegistro', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fechaRegistro" control={control} rules={getValidationRules('tenant.fechaRegistro', stepKey)} render={({ field }) => (
                        <Calendar id="tenant.fechaRegistro" {...field} value={field.value} onChange={(e) => field.onChange(e.value)} className="w-full" dateFormat="yy-mm-dd" showIcon style={{
                            borderRadius: '17px',
                            overflow: 'hidden',
                            padding: '0',
                            width: '300px',
                            // height: '47px',
                            '& input': {
                                padding: '0.5rem 1rem',
                                borderRadius: '0px',
                            }
                        }} panelStyle={{
                            borderRadius: '17px'
                        }}/>
                    )} />
                    {errors.tenant?.fechaRegistro && <small className="p-error">{errors.tenant.fechaRegistro.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.actividadEconomica">Act. económica {isFieldRequired('tenant.actividadEconomica', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.actividadEconomica" control={control} rules={getValidationRules('tenant.actividadEconomica', stepKey)} render={({ field }) => (
                        <InputText id="tenant.actividadEconomica" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.actividadEconomica && <small className="p-error">{errors.tenant.actividadEconomica.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.numeroEscritura">N. Escritura {isFieldRequired('tenant.numeroEscritura', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.numeroEscritura" control={control} rules={getValidationRules('tenant.numeroEscritura', stepKey)} render={({ field }) => (
                        <InputText id="tenant.numeroEscritura" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.numeroEscritura && <small className="p-error">{errors.tenant.numeroEscritura.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.libro">Libro {isFieldRequired('tenant.libro', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.libro" control={control} rules={getValidationRules('tenant.libro', stepKey)} render={({ field }) => (
                        <InputText id="tenant.libro" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.libro && <small className="p-error">{errors.tenant.libro.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.fedatarioNumero">Fedatario No. {isFieldRequired('tenant.fedatarioNumero', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fedatarioNumero" control={control} rules={getValidationRules('tenant.fedatarioNumero', stepKey)} render={({ field }) => (
                        <InputText id="tenant.fedatarioNumero" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.fedatarioNumero && <small className="p-error">{errors.tenant.fedatarioNumero.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-3'}`}>
                    <label htmlFor="tenant.entidadFederativa">Entidad Fed. {isFieldRequired('tenant.entidadFederativa', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.entidadFederativa" control={control} rules={getValidationRules('tenant.entidadFederativa', stepKey)} render={({ field }) => (
                        <InputText id="tenant.entidadFederativa" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.entidadFederativa && <small className="p-error">{errors.tenant.entidadFederativa.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label htmlFor="tenant.fedatarioNombre">Nombre (Fedatario) {isFieldRequired('tenant.fedatarioNombre', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.fedatarioNombre" control={control} rules={getValidationRules('tenant.fedatarioNombre', stepKey)} render={({ field }) => (
                        <InputText id="tenant.fedatarioNombre" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.fedatarioNombre && <small className="p-error">{errors.tenant.fedatarioNombre.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-6'}`}>
                    <label htmlFor="tenant.opinionCumplimiento">Opinión Cumplí.{isFieldRequired('tenant.opinionCumplimiento', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.opinionCumplimiento" control={control} rules={getValidationRules('tenant.opinionCumplimiento', stepKey)} render={({ field }) => (
                        <InputText id="tenant.opinionCumplimiento" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.opinionCumplimiento && <small className="p-error">{errors.tenant.opinionCumplimiento.message}</small>}
                </div>
            </div>

            <div className="formgrid grid">
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.estatus">Estatus {isFieldRequired('tenant.estatus', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.estatus" control={control} rules={getValidationRules('tenant.estatus', stepKey)} render={({ field }) => (
                        <InputText id="tenant.estatus" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.estatus && <small className="p-error">{errors.tenant.estatus.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.idCIF">IdCIF {isFieldRequired('tenant.idCIF', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.idCIF" control={control} rules={getValidationRules('tenant.idCIF', stepKey)} render={({ field }) => (
                        <InputText id="tenant.idCIF" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.idCIF && <small className="p-error">{errors.tenant.idCIF.message}</small>}
                </div>
                <div className={`field ${isSmall ? 'col-12' : 'col-4'}`}>
                    <label htmlFor="tenant.regimenFiscal">Régimen Fiscal {isFieldRequired('tenant.regimenFiscal', stepKey) && <span className="required-asterisk"> *</span>}</label>
                    <Controller name="tenant.regimenFiscal" control={control} rules={getValidationRules('tenant.regimenFiscal', stepKey)} render={({ field }) => (
                        <InputText id="tenant.regimenFiscal" {...field} className="w-full" />
                    )} />
                    {errors.tenant?.regimenFiscal && <small className="p-error">{errors.tenant.regimenFiscal.message}</small>}
                </div>
            </div>
        </div>
    );
}


